export default __webpack_public_path__ + "static/media/money-back@2x.0eaaca87.png";